import { postApi } from "../apis";

export const loginWithSso = (data) =>
    postApi(`user/login/sso`, data, {
        headers: { Authorization: "Bearer undefined" },
    });
